var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7396 2.97211H12.2278V0.999891C12.2278 0.693058 11.9791 0.444336 11.6722 0.444336H4.32783C4.021 0.444336 3.77228 0.693058 3.77228 0.999891V2.97211H2.2605C1.50422 2.97211 0.888916 3.59517 0.888916 4.361V9.63878C0.888916 10.4046 1.50422 11.0277 2.2605 11.0277H3.77225V12.9999C3.77225 13.3067 4.02097 13.5554 4.3278 13.5554H11.6722C11.979 13.5554 12.2277 13.3067 12.2277 12.9999V11.0277H13.7395C14.4958 11.0277 15.1111 10.4046 15.1111 9.63878V4.361C15.1111 3.59517 14.4958 2.97211 13.7396 2.97211ZM4.88339 1.55545H11.1167V2.97211H4.88339V1.55545ZM4.88339 12.4443C4.88339 12.3996 4.88339 8.38361 4.88339 8.24989H11.1167C11.1167 8.38361 11.1167 12.3996 11.1167 12.4443H4.88339ZM13.7396 9.91656H12.2278V8.24989H12.7222C13.0291 8.24989 13.2778 8.00117 13.2778 7.69434C13.2778 7.3875 13.0291 7.13878 12.7222 7.13878C12.3877 7.13878 3.65164 7.13878 3.2778 7.13878C2.97097 7.13878 2.72225 7.3875 2.72225 7.69434C2.72225 8.00117 2.97097 8.24989 3.2778 8.24989H3.77228V9.91656H2.2605C2.11689 9.91656 2.00003 9.79195 2.00003 9.63878V4.361C2.00003 4.20784 2.11689 4.08322 2.2605 4.08322C2.44597 4.08322 13.5255 4.08322 13.7395 4.08322C13.8832 4.08322 14 4.20784 14 4.361V9.63878H14C14 9.79195 13.8832 9.91656 13.7396 9.91656Z",
    fill: "#5B9BCC",
    stroke: "#5B9BCC",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.fb653736.svg";
export { ForwardRef as ReactComponent };